module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("By")]), _vm._v(" L.J. L"), _c('span', {
    staticClass: "t3"
  }, [_vm._v("A")]), _vm._v("B"), _c('span', {
    staticClass: "t3"
  }, [_vm._v("ARTHE")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("The Body on the Beach")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("City of Jade")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Long Road Back")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Piece Us Back Together (Multiple Author Anthology)")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Swimming with Elephants")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Ties that Bind")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Under the Southern Cross (Dreamspinner Anthology)")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Waiting for the Moon and You")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t4"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "t5"
  }, [_vm._v("RCHANGEL")]), _vm._v(" "), _c('span', {
    staticClass: "t4"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "t5"
  }, [_vm._v("HRONICLES")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("No Quarter")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("No Surrender, No Retreat")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("No Shadows Fall")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("The Wind-up Forest")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("The Crystal Lake")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("The Bone Cup")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("A Shot in the Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("A Fire in the Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("Published by")]), _vm._v(" D"), _c('span', {
    staticClass: "t3"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" P"), _c('span', {
    staticClass: "t3"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t1"
  }, [_vm._v("http://www.dreamspinnerpress.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47993f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/002.vue
// module id = 57
// module chunks = 0